module.exports = __webpack_public_path__ + "img/bday.95aacf16.png";